import useNotificationService from '@contexts/useNotificationService';
import { useAuthStore, useSafeContext } from '@sunrise-ui/primitives';
import React, {
  createContext,
  useEffect,
  useState,
  type PropsWithChildren,
} from 'react';

type BidContextHistoryType = {
  hasPreviouslyBid: boolean;
  setHasPreviouslyBid: (value: boolean) => void;
};

// @ts-expect-error -- don't use default, instead console error if component not used in appropriate context
const BidHistoryContext = createContext<BidContextHistoryType>();
BidHistoryContext.displayName = 'BidHistoryContext';

export const BidHistoryProvider = ({ children }: PropsWithChildren) => {
  const { notificationService } = useNotificationService();
  const { currentUserId } = useAuthStore();
  const [hasPreviouslyBid, setHasPreviouslyBid] = useState(false);

  useEffect(() => {
    if (notificationService) {
      return notificationService.addListener('NewHighestBidPlaced', (event) => {
        if (event.user_id === currentUserId) setHasPreviouslyBid(true);
      });
    }
  }, [notificationService]);

  useEffect(() => {
    if (notificationService) {
      return notificationService.addListener('AuctionRoundClosed', (event) => {
        if (event.user_id === currentUserId) setHasPreviouslyBid(false);
      });
    }
  }, [notificationService]);

  return (
    <BidHistoryContext.Provider
      value={{
        hasPreviouslyBid,
        setHasPreviouslyBid,
      }}
    >
      {children}
    </BidHistoryContext.Provider>
  );
};

export default function useBidHistory() {
  return useSafeContext(BidHistoryContext);
}
